export default {"src":"/_next/static/media/top.285b7ffa.svg","height":140,"width":262};